import { render, staticRenderFns } from "./CriteriaChips.vue?vue&type=template&id=32188c0a&"
import script from "./CriteriaChips.vue?vue&type=script&lang=js&"
export * from "./CriteriaChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports